// extracted by mini-css-extract-plugin
module.exports =  {"SelectorButton":"yuno2IXS9pI5rSWKWN5m","SelectorButton__Switch":"XoY8Dh19cBrt_3ww6sLj","SelectorButton__List":"IkfcfV5tLancVqD2i0NE"};